/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Analyse_Changed_NoticeInputs */

const en_upload_analyse_changed_notice = /** @type {(inputs: Upload_Analyse_Changed_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The document list has changed since it was last processed. Process the documents again to refresh the results.`)
};

const pt_br2_upload_analyse_changed_notice = /** @type {(inputs: Upload_Analyse_Changed_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A lista de documentos mudou desde o último processamento. Processe os documentos novamente para atualizar os resultados.`)
};

/**
* | output |
* | --- |
* | "The document list has changed since it was last processed. Process the documents again to refresh the results." |
*
* @param {Upload_Analyse_Changed_NoticeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_analyse_changed_notice = /** @type {((inputs?: Upload_Analyse_Changed_NoticeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Analyse_Changed_NoticeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_analyse_changed_notice(inputs)
	return pt_br2_upload_analyse_changed_notice(inputs)
});